"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseApolloServiceQueryToGDP = parseApolloServiceQueryToGDP;
exports.parseCELQuery = parseCELQuery;
exports.parseGDPQuery = parseGDPQuery;
exports.parseParamValue = parseParamValue;
var _constants = require("./constants");
var _gdpToApollo = require("./gdpToApollo");
var _celToApollo = require("./celToApollo");
var _apolloToGdp = require("./apolloToGdp");
var _utils = require("./utils");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function parseCELQuery(search) {
  if (!search) return null;
  var inputQueryParams = new URLSearchParams(search);
  if (inputQueryParams.search) return parseGDPQuery(search);
  var params = (0, _celToApollo.separateParams)((0, _utils.getQueryParams)(search));
  var createdParams = (0, _utils.createParams)(params);
  var result = (0, _utils.sortOptionsBy)(createdParams, _constants.KEY);
  return result;
}
function parseGDPQuery(search) {
  var params = (0, _gdpToApollo.separateParams)((0, _utils.getQueryParams)(search));
  var foundParams = params.others.filter(function (p) {
    return [_constants.QUERY_PARAM_QUALIFIERS, _constants.QUERY_PARAM_SEARCH, _constants.QUERY_PARAM_SORT].includes(p.key);
  });
  if (foundParams.length > 0) {
    return (0, _utils.sortOptionsBy)(params.others, _constants.KEY);
  }
  var createdParams = (0, _utils.createParams)(params);
  if ((createdParams === null || createdParams === void 0 ? void 0 : createdParams.length) > 0) {
    return (0, _utils.sortOptionsBy)(createdParams, _constants.KEY);
  }
  return null;
}
function parseParamValue(paramValue) {
  var params = null;
  if (paramValue && paramValue !== "") {
    var queryStringArray = paramValue.split(_constants.SYMBOL_QUERY_PARAM_DIVIDER);
    queryStringArray.forEach(function (qsa) {
      var _qsa$split = qsa.split(_constants.SYMBOL_QUERY_PARAM_ALLOCATOR),
        _qsa$split2 = _slicedToArray(_qsa$split, 2),
        key = _qsa$split2[0],
        value = _qsa$split2[1];
      if (key && key !== "") {
        if (!params) {
          params = {};
        }
        params[key] = (0, _utils.getParamValue)(value);
      }
    });
  }
  return (0, _utils.sortParams)(params);
}
function parseApolloServiceQueryToGDP(queryString) {
  var paramsObject = (0, _apolloToGdp.createParamsObject)(queryString);
  var filtersParsed = (0, _apolloToGdp.parseFiltersToGDP)(paramsObject);
  var gdpQuery = (0, _apolloToGdp.createGDPQuery)(filtersParsed);
  return gdpQuery ? "?".concat(gdpQuery) : null;
}